// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_2U3","content":"styles_content__1B_r-"};